import React, { PureComponent } from 'react'
import { Table } from 'react-bootstrap'
import { formatSnakeCaseToSpaceCase, formatTimeString } from '../../../utils/formatters'
import AuditLogs from './audit_logs'
import AlertInformation from './alert_information'
import AcuantAlerts from './acuant_alerts'

class TransactionMetadata extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showAcuantAlerts: false,
      showAuditLogs: false,
      acuantAlertsIconClass: 'cursor-pointer fa fa-plus-square-o',
      auditLogsIconClass: 'cursor-pointer fa fa-plus-square-o',
    }
  }

  isScalar = (val) => {
    return typeof val !== 'object'
  }

  processMetadata = (metadata) => {
    return Object.keys(metadata).map((key) => {
      let obj = {}
      switch (key.toLowerCase()) {
        case 'id':
          obj = { ...obj, ...{ ID: metadata[key] } }
          break
        case 'created':
        case 'updated':
          obj = { ...obj, ...{ [formatSnakeCaseToSpaceCase(key)]: formatTimeString(metadata[key]) } }
          break
        case 'sdk_version':
          obj = { ...obj, ...{ 'SDK Version': metadata[key] } }
          break
        case 'alert_information':
          obj = {
            ...obj,
            ...{
              [formatSnakeCaseToSpaceCase(key)]: (
                <AlertInformation processMetadata={this.processMetadata} obj={metadata[key]} />
              ),
            },
          }
          break
        case 'acuant_alerts':
          obj = {
            ...obj,
            ...{
              [formatSnakeCaseToSpaceCase(key)]:
                metadata[key] && metadata[key].length ? (
                  <AcuantAlerts
                    isShown={this.state.showAcuantAlerts}
                    processMetadata={this.processMetadata}
                    data={metadata[key]}
                  />
                ) : null,
            },
          }
          break
        case 'audit_logs':
          obj = {
            ...obj,
            ...{
              [formatSnakeCaseToSpaceCase(key)]:
                metadata[key] && metadata[key].length ? (
                  <AuditLogs
                    isShown={this.state.showAuditLogs}
                    processMetadata={this.processMetadata}
                    data={metadata[key]}
                  />
                ) : null,
            },
          }
          break
        default:
          if (this.isScalar(metadata[key])) {
            obj = { ...obj, ...{ [formatSnakeCaseToSpaceCase(key)]: metadata[key].toString() } }
          } else {
            let val = null
            if (metadata[key] === null) {
              val = ''
            } else {
              if (metadata[key].constructor === Array) {
                val = metadata[key].length ? JSON.stringify(metadata[key]) : ''
              } else {
                val = JSON.stringify(metadata[key])
              }
            }

            obj = { ...obj, ...{ [formatSnakeCaseToSpaceCase(key)]: val } }
          }
      }
      return obj
    })
  }

  handleShowAuditLogs = () => {
    const invertState = !this.state.showAuditLogs
    const iconCls = invertState ? 'cursor-pointer fa fa-minus-square-o' : 'cursor-pointer fa fa-plus-square-o'
    this.setState({ showAuditLogs: invertState, auditLogsIconClass: iconCls })
  }

  handleShowAcuantAlerts = () => {
    const invertState = !this.state.showAcuantAlerts
    const iconCls = invertState ? 'cursor-pointer fa fa-minus-square-o' : 'cursor-pointer fa fa-plus-square-o'
    this.setState({ showAcuantAlerts: invertState, acuantAlertsIconClass: iconCls })
  }

  render() {
    const auditLogs = 'Audit Logs'
    const acuantAlerts = 'Acuant Alerts'

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>Transaction Metadata</h5>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
          {this.props.metadata ? (
            <Table striped bordered hover>
              <tbody>
                {this.processMetadata(this.props.metadata).map((obj, i) => {
                  let style = {}
                  let expandIcon = null
                  const objKey = Object.keys(obj)[0]
                  if ((objKey === auditLogs || objKey === acuantAlerts) && obj[Object.keys(obj)[0]]) {
                    style = { padding: '0' }
                    expandIcon = (
                      <i
                        className={
                          objKey === auditLogs ? this.state.auditLogsIconClass : this.state.acuantAlertsIconClass
                        }
                        aria-hidden='true'
                        onClick={objKey === auditLogs ? this.handleShowAuditLogs : this.handleShowAcuantAlerts}
                      />
                    )
                  }

                  return (
                    <tr key={i}>
                      <td className='td-nowrap'>
                        <strong>{Object.keys(obj)[0]}</strong> {expandIcon}
                      </td>
                      <td style={style}>{obj[Object.keys(obj)[0]]}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
        </div>
      </div>
    )
  }
}

export default TransactionMetadata
